import { Modal } from 'bootstrap';
import * as Yup from 'yup';
import { phoneNumberValidation } from './yup-validation';
import EcodigoForm from './ecodigo-form';

declare global {
  interface Window {
    grecaptcha: unknown;
  }
}

export default (): void => {
  const grecaptcha = window.grecaptcha;
  const recaptchaToken = document.querySelector('meta[name="google-recaptcha"]')?.getAttribute('content');
  const jobModalElement: HTMLElement | null = document.querySelector('#jobFormModal');
  const jobModal = jobModalElement ? new Modal(jobModalElement) : null;
  const jobForm = jobModalElement ? (jobModalElement.querySelector('form') as HTMLFormElement) : null;

  if (!jobModalElement || !jobModal || !jobForm) return;

  const fields = ['lastname', 'firstname', 'phone', 'email', 'job', 'message', 'files'];

  const schema = Yup.object().shape({
    lastname: Yup.string()
      .required('Le nom est requis')
      .min(2, 'Le nom doit contenir au moins 2 caractères')
      .max(50, 'Le nom ne peut pas dépasser 50 caractères'),
    firstname: Yup.string()
      .required('Le nom est requis')
      .min(2, 'Le nom doit contenir au moins 2 caractères')
      .max(50, 'Le nom ne peut pas dépasser 50 caractères'),
    phone: Yup.string().test(phoneNumberValidation).required('Le numéro de téléphone est requis'),
    email: Yup.string().required("L'email est requis").email("L'email n'est pas valide"),
    message: Yup.string()
      .required('Le message est requis')
      .min(10, 'Le message doit contenir au moins 10 caractères')
      .max(500, 'Le message ne peut pas dépasser 1000 caractères'),
    job: Yup.string(),
    files: Yup.mixed().test({
      name: 'required-file',
      message: 'Veuillez sélectionner au moins un fichier',
      test: function (inputFiles) {
        const isSet = inputFiles && typeof inputFiles === 'object' && 'size' in inputFiles;

        if (isSet) {
          return (inputFiles as Set<File>).size > 0;
        }

        return false;
      },
    }),
  });

  const form = new (class extends EcodigoForm {
    constructor() {
      if (!jobModalElement || !jobModal || !jobForm) return;

      super(jobModalElement, jobForm, fields, schema, grecaptcha, recaptchaToken, false);

      this.submitForm = async (): Promise<boolean> => {
        this.triggerErrors = true;

        const formData = new FormData();
        const dataObject = this.getDataObject();

        fields.forEach((fieldName) => {
          const input = jobForm?.querySelector(`[name=${fieldName}]`) as HTMLInputElement;
          const value = input.value;
          formData.append(fieldName, value);
        });

        this.fileUploader?.getFiles().forEach((file) => {
          formData.append('files[]', file);
        });

        fields.forEach((fieldName) => {
          this.showError(fieldName, '');
        });

        try {
          await schema.validate(dataObject, { abortEarly: false });

          const values = {
            recaptcha: undefined,
            ...formData,
          };

          // @ts-expect-error grecaptcha is defined
          await new Promise((resolve) => this.grecaptcha.ready(resolve));
          // @ts-expect-error grecaptcha is defined
          values.recaptcha = await this.grecaptcha.execute(recaptchaToken, { action: 'submitForm' });
          if (values.recaptcha) {
            formData.append('recaptcha', values.recaptcha);
          }

          const sendData = await fetch('/wp-json/ecodigo/job_form', {
            method: 'POST',
            body: formData,
          });

          await this.handleSubmitResponse(sendData);
        } catch (err) {
          (err as Yup.ValidationError).inner.forEach((error: Yup.ValidationError) => {
            this.showError(error.path ?? '', error.message);
          });
        }

        return true;
      };
    }
  })();

  form.init();
};
